export default "__VITE_ASSET__euKyZIbS__"